// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.13f5b97f',
  revision: '13f5b97f',
  branch: 'develop',
  date: 'Mon, 16 Mar 2026 15:56:53 GMT'
};